/**
 * Event Listings - Dropdown and count functionality
 * Tab switching is now handled by the event_status radio facet
 */

function init() {
    const countElement = document.querySelector('.event-listings__count');
    if (!countElement) {
        return;
    }

    // Update event counts when FacetWP refreshes
    document.addEventListener('facetwp-loaded', function() {
        if (typeof FWP === 'undefined') {
            return;
        }

        const template = document.querySelector('.event-listings__upcoming-posts[data-template="events"]');
        const totalRows = template
            ? template.querySelectorAll('.m-card-event').length
            : 0;
        
        const countNumber = countElement.querySelector('.event-listings__count-number');
        const countLabel = countElement.querySelector('.event-listings__count-label');
        
        if (countNumber) {
            countNumber.textContent = totalRows;
        }
        
        if (countLabel) {
            // Use internationalized singular/plural from data attributes
            const singular = countElement.getAttribute('data-singular') || 'Event';
            const plural = countElement.getAttribute('data-plural') || 'Events';
            countLabel.textContent = totalRows === 1 ? singular : plural;
        }
    });

    // Helper function to check if window is desktop size (>= 833px)
    function isDesktop() {
        return window.innerWidth >= 833;
    }

    // Desktop dropdown behavior (>= 833px)
    const eventFilters = document.querySelectorAll('.event-filter');
    
    // Function to close all desktop dropdowns
    function closeAllDesktopDropdowns() {
        eventFilters.forEach(filter => {
            filter.classList.remove('active');
        });
    }
    
    // Desktop dropdown handlers - only active when >= 833px
    eventFilters.forEach(filter => {
        // Get the first direct child span (the trigger)
        const trigger = filter.firstElementChild;
        if (!trigger || trigger.tagName !== 'SPAN') return;
        
        // Toggle dropdown on trigger click (desktop only)
        trigger.addEventListener('click', function(e) {
            if (!isDesktop()) return; // Only work on desktop
            
            e.stopPropagation(); // Prevent event from bubbling to document
            
            // Check if this dropdown is currently active
            const isCurrentlyActive = filter.classList.contains('active');
            
            // Close all dropdowns first
            closeAllDesktopDropdowns();
            
            // If this one wasn't active, open it (toggle behavior)
            if (!isCurrentlyActive) {
                filter.classList.add('active');
            }
        });
    });
    
    // Close desktop dropdowns when clicking outside (desktop only)
    document.addEventListener('click', function(e) {
        if (!isDesktop()) return; // Only work on desktop
        
        // Check if the click is outside any event-filter
        const clickedFilter = e.target.closest('.event-filter');
        if (!clickedFilter) {
            // Click was outside, close all dropdowns
            closeAllDesktopDropdowns();
        }
    });

    // Mobile dropdown behavior (< 833px)
    const filterByTrigger = document.getElementById('filterBy');
    
    if (filterByTrigger) {
        // Function to get the parent filters container
        function getFiltersContainer() {
            return filterByTrigger.closest('.event-listings__filters');
        }

        // Function to remove mobile-active class
        function closeMobileDropdown() {
            const filterByContainer = getFiltersContainer();
            if (filterByContainer) {
                filterByContainer.classList.remove('mobile-active');
            }
        }

        // Toggle mobile dropdown on filterBy click (mobile only)
        filterByTrigger.addEventListener('click', function(e) {
            if (isDesktop()) return; // Only work on mobile
            
            e.stopPropagation();
            const filterByContainer = getFiltersContainer();
            if (filterByContainer) {
                filterByContainer.classList.toggle('mobile-active');
            }
        });

        // Close mobile dropdown when clicking checkboxes (mobile only)
        const checkboxes = document.querySelectorAll('.event-filter input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', function() {
                if (isDesktop()) return; // Only work on mobile
                closeMobileDropdown();
            });
        });

        // Close mobile dropdown when clicking outside the filters container (mobile only)
        document.addEventListener('click', function(e) {
            if (isDesktop()) return; // Only work on mobile
            
            const filterByContainer = getFiltersContainer();
            if (filterByContainer && !filterByContainer.contains(e.target) && e.target !== filterByTrigger) {
                closeMobileDropdown();
            }
        });
    }

    // Handle window resize - clean up active states
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            // Remove mobile-active class on resize
            if (filterByTrigger) {
                const filterByContainer = filterByTrigger.closest('.event-listings__filters');
                if (filterByContainer) {
                    filterByContainer.classList.remove('mobile-active');
                }
            }

            // Remove active class from desktop dropdowns on resize
            closeAllDesktopDropdowns();
        }, 100);
    });
}

export { init as default };
